import { VaultDocumentDTO } from "../DTO/vaultDocumentDTO";
import { VaultDocumentWithFileDTO } from "../DTO/vaultDocumentWithFileDTO";
import { AbstractDocument } from "./abstractDocument";
import { VisibleTo } from "./visibleTo";

export class VaultDocument{
    public id?:number;
    public businessId!:string;
    public clientId?:number;
    public filename?:string;
    public description?:string;
    public filepath!:string;
    public contentType?:string; //mime type
    public context?:string; //example: 'property'
    public contextId?:number;
    public contextHeader?:string;
    public subContextId?:number; 
    public restrictedToUserId?:string;
    public visibility?:number; //public scope: 0=not public, 2=public NDA required, 9=public (1 no longer used)
    /** roles that see the (not public) document besides super admins, see VisibleTo; undefined = not specified */
    public visibleTo?:number;
    public documentTypeId!:number;
    public added?:Date;
    public addedByUser?:string;
    public addedByUserFullName?:string;
    public edited?:Date;
    public lastEditedByUser?:string;
    public lastEditedByUserFullName?:string;
    public folderStructureId?:number;
    public folderStructurePath?:string;
    public categoryType?: string; //example: 'task','party'
    public categorySubType?: string; //example: 'order_appointing_receiver'
    public categoryId?: number; //example: propertyTask.id, propertyParty.id


    public tempId?:number; //used when uploading new vaultDocument to temporarily identify the VaultDocument in the UI
    public file?:File; //used when uploading new vaultDocument to temporarily reference the File with the vaultDocument
    public updated:boolean = false; //flag used for determining if we need to update the data server side

    private abstractDocument?:AbstractDocument;

    public static mapToDTO(param:VaultDocument):VaultDocumentDTO{ 
        
        let dto = new VaultDocumentDTO();
        try
        {
            dto.id = param.id;
            dto.businessId = param.businessId;
            dto.clientId = param.clientId;
            dto.filename = param.filename;
            dto.description = param.description;
            dto.filepath = param.filepath;
            dto.contentType = param.contentType;
            dto.context = param.context;
            dto.contextId = param.contextId;
            dto.contextHeader = param.contextHeader;
            dto.subContextId = param.subContextId;
            dto.restrictedToUserId = param.restrictedToUserId;
            dto.visibility = param.visibility;
            dto.visibleTo = param.visibleTo;
            dto.documentTypeId = param.documentTypeId;
            dto.addedByUser = param.addedByUser;
            dto.addedByUserFullName = param.addedByUserFullName;
            if(param.added) dto.added = param.added.toISOString();
            dto.lastEditedByUser = param.lastEditedByUser;
            if(param.edited) dto.edited = param.edited.toISOString();
            dto.folderStructureId = param.folderStructureId;
            dto.folderStructurePath = param.folderStructurePath;
            dto.categoryType = param.categoryType;
            dto.categorySubType = param.categorySubType;
            dto.categoryId = param.categoryId;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    public static mapFromDTO(param:VaultDocumentDTO|VaultDocumentWithFileDTO):VaultDocument{ 
        
      
        let obj = new VaultDocument();
        try
        {
            obj.id = param.id;
            obj.businessId = param.businessId;
            obj.clientId = param.clientId;
            obj.filename = param.filename;
            obj.description = param.description;
            obj.filepath = param.filepath;
            obj.contentType = param.contentType;
            obj.context = param.context;
            obj.contextId = param.contextId;
            obj.contextHeader = param.contextHeader;
            obj.subContextId = param.subContextId;
            obj.restrictedToUserId = param.restrictedToUserId;
            obj.visibility = param.visibility;
            obj.visibleTo = param.visibleTo ?? undefined;
            obj.documentTypeId = param.documentTypeId;
            obj.addedByUser = param.addedByUser;
            obj.addedByUserFullName = param.addedByUserFullName;
            if(param.added) obj.added = new Date(param.added);
            obj.lastEditedByUser = param.lastEditedByUser;
            if(param.edited) obj.edited =new Date(param.edited);
            obj.folderStructureId = param.folderStructureId;
            obj.folderStructurePath = param.folderStructurePath;
            obj.categoryType = param.categoryType;
            obj.categorySubType = param.categorySubType;
            obj.categoryId = param.categoryId;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    get displayContextHeader():string{
        if(this.contextHeader && this.contextHeader.trim().length>0){
            return this.contextHeader;
        }
        else return "General";
    }

    get isVisibleToClient():boolean{
        return VisibleTo.includes(this.visibleTo, VisibleTo.Client);
    }

    get isBuyerExecuted():boolean{
        return this.documentTypeId===4 || this.documentTypeId===5 || this.documentTypeId===6;
    }

    get abstract(){
        if(!this.abstractDocument){
            this.abstractDocument = new AbstractDocument();
            this.abstractDocument.id=((this.id && this.id>0)?this.id:this.tempId)!;
            this.abstractDocument.name=this.filename;
            this.abstractDocument.description=this.description;
            this.abstractDocument.typeId=this.documentTypeId;
            this.abstractDocument.date=this.edited;
            this.abstractDocument.isLegalAd=false;
            this.abstractDocument.contentType=this.contentType;
            this.abstractDocument.visibility=this.visibility;
            this.abstractDocument.visibleTo=this.visibleTo;
            this.abstractDocument.documentReference=this.filepath;
            this.abstractDocument.folderStructurePath=this.folderStructurePath;
            this.abstractDocument.userName  =this.addedByUser;
            this.abstractDocument.userFullName = this.addedByUserFullName;
        }
        return this.abstractDocument;
    }

    public updateAbstract(){
        if(this.abstractDocument){
            this.abstractDocument.name=this.filename;
            this.abstractDocument.description=this.description;
            this.abstractDocument.typeId=this.documentTypeId;
            this.abstractDocument.date=this.edited;
            this.abstractDocument.contentType=this.contentType;
            this.abstractDocument.visibility=this.visibility;
            this.abstractDocument.visibleTo=this.visibleTo;
            this.abstractDocument.documentReference=this.filepath;
            this.abstractDocument.folderStructurePath=this.folderStructurePath;
        }
    }

}